<template>
    <span>
        <span v-if="inventory && inventory.status == 'queued'">
            <span class="fa fa-clock-o"></span> Queued
        </span>
        <span v-if="inventory && inventory.status == 'parsing'">
            <span class="fa fa-gear fa-spin"></span> Parsing...
        </span>
        <span v-if="inventory && inventory.status == 'matching'">
            <span class="fa fa-gear fa-spin"></span> Matching Amazon Products...
        </span>
        <span v-if="inventory && inventory.status == 'error'" class="text-red">
            <span class="fa fa-times-circle"></span> Error
        </span>
        <span v-if="inventory && inventory.status == 'ready'" class="text-green">
            <span class="fa fa-check-circle"></span> Ready
        </span>
    </span>
</template>

<script>
    export default {
        props: ['inventory'],
    }
</script>
